// Module
var code = "<style include=\"common-transition-styles common-app-styles\">:host{position:fixed;display:none;top:0;bottom:0;left:0;right:0;overflow:hidden;background:var(--global-overlay-background);z-index:var(--z-overlay);@apply --ns-overlay;}:host([theme=light]){background:var(--global-overlay-light-background)}</style> <section></section> ";
// Exports
module.exports = code;